import { useState, useEffect } from "react";
import cn from "classnames";
import _find from "lodash/find";
import Select from "../../../audi-ui-components/Select";
import GeoPostcodeField from "./GeoPostcodeField";
import { 
  STATES_OPTIONS,
  DEFAULT_THEME,
} from "../../../constants";

import { connect } from "react-redux";
import {
  fetchSuburbsByPostcode
} from "../../../redux/Dealers";
const mapStateToProps = state => {
  return {
    isLoadingSuburbs: state.dealers.isLoadingSuburbs
  };
}
const mapDispatchToProps = dispatch => {
  return {
    fetchSuburbsByPostcode: (p, cb, errCb) => {dispatch(fetchSuburbsByPostcode(p, cb, errCb));}
  }
}

const SearchForm = ({
  title = "Find a dealer or service centre",
  searchBy = "postcode",
  filter = "all",
  postcode = "",
  state = "",
  searchFilters = false,
  error = null,
  theme = DEFAULT_THEME,
  className = "",
  onChangeState = ()=>{},
  onSubmit = ()=>{},
  fetchSuburbsByPostcode,
}) => {
  //
  const auiTheme = (theme === "dark" ? "light" : null);
  const [searchFor, setSearchFor] = useState(filter);
  const [searchPostcode, setSearchPostcode] = useState(postcode);
  const [searchSuburb, setSearchSuburb] = useState("");
  const [searchSuburbId, setSearchSuburbId] = useState(null);
  const [searchState, setSearchState] = useState(state);
  const [errors, setErrors] = useState(null);

  const handleChangeSearchFor = (e) => {
    // console.log(e.target.value);
    setSearchFor(e.target.value);
    setErrors(null);
  }

  const handleChangeLocation = (addressComponents) => {
    setSearchPostcode(addressComponents.postcode);
    setSearchSuburb(addressComponents.suburb);
  }

  const handleChangeState = (v) => {
    if (typeof onChangeState === "function") {
      onChangeState(v);
    }
    setSearchState(v);
    setErrors(null);
  }

  useEffect(() => {
    if (searchBy === "suburb" && searchPostcode && searchSuburb) {
      fetchSuburbsByPostcode(searchPostcode, (suburbs) => {
        // console.log(suburbs);
        let suburb = _find(suburbs, {label: searchSuburb});
        if (suburb?.value) {
          setSearchSuburbId(suburb.value);
        } else {
          onSubmit({
            searchBy: "postcode",
            searchFor: searchFor,
            postcode: searchPostcode,
          }, searchPostcode);
        }
      });
    }
  }, [searchSuburb, searchPostcode]);

  useEffect(() => {
    if (
      (searchBy === "postcode" && searchPostcode) || 
      (searchBy === "suburb" && searchSuburbId) ||
      (searchBy === "state" && searchState)
    ) {
      onSubmit({
        searchBy: searchBy,
        searchFor: searchFor,
        postcode: searchPostcode,
        suburb: searchSuburbId,
        state: searchState,
      });
    }
  }, [searchFor, searchPostcode, searchSuburbId, searchState]);

  return (
    <div className={cn("locate__search-form p-4", className)}>

      <h2 className="mb-2">{title}</h2>

      {(searchBy === "postcode" || searchBy === "suburb") && <div className="mb-3">
        <GeoPostcodeField name="searchPostcode"
          value={searchPostcode || ""}
          label="Enter your postcode to find your local dealer"
          onChange={handleChangeLocation}
          isInvalid={errors?.postCode}
          invalidMessage={errors?.postCode || null}
          theme={auiTheme}
        />
      </div>}

      {searchBy === "state" &&
        <Select name="dealerState"
          value={searchState}
          label="Select a state"
          options={STATES_OPTIONS}
          onChange={handleChangeState}
          isInvalid={errors?.state}
          invalidMessage={errors?.state || null}
          className="mb-5"
          theme={auiTheme}
        />
      }

      {searchFilters && <div className="locate__search-for">
        <p className="mb-2">I'm looking for</p>
        <div className="">
          <label className={cn({"is-checked": searchFor === "all"})}>
            <input name="searchFor" type="radio" className="aui-radio__input" value="all" checked={searchFor === "all"} onChange={handleChangeSearchFor} />
            All locations
          </label>
          <label className={cn({"is-checked": searchFor === "Sales"})}>
            <input name="searchFor" type="radio" className="aui-radio__input" value="Sales" checked={searchFor === "Sales"} onChange={handleChangeSearchFor} />
            Sales dealerships
          </label>
          <label className={cn({"is-checked": searchFor === "Service"})}>
            <input name="searchFor" type="radio" className="aui-radio__input" value="Service" checked={searchFor === "Service"} onChange={handleChangeSearchFor} />
            Service centres
          </label>
          <label className={cn({"is-checked": searchFor === "RepairCentre"})}>
            <input name="searchFor" type="radio" className="aui-radio__input" value="RepairCentre" checked={searchFor === "RepairCentre"} onChange={handleChangeSearchFor} />
            Approved repairers
          </label>
          <label className={cn({"is-checked": searchFor === "TradePartCentre"})}>
            <input name="searchFor" type="radio" className="aui-radio__input" value="TradePartCentre" checked={searchFor === "TradePartCentre"} onChange={handleChangeSearchFor} />
            Trade parts
          </label>
        </div>
      </div>}

      {error && <p className="mb-5 aui-color-text-red">{error}</p>}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);
